import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CtaSection } from './CtaSection';
export function OfferSection() {
  const items = [{
    icon: '📘',
    title: 'Ebook: 2026 Credit Architecture',
    desc: 'The step-by-step manual to dominate FICO 10T.',
    value: 197
  }, {
    icon: '🎁',
    title: 'Bonus 1: The 2026 Anti-AI Letter Vault',
    desc: 'Letters written with Metro 2 codes that bypass both human and robotic filters.',
    value: 97
  }, {
    icon: '🎁',
    title: 'Bonus 2: Secondary Data Inhibition Guide',
    desc: 'How to go invisible to LexisNexis and SageStream.',
    value: 67
  }, {
    icon: '🎁',
    title: 'Bonus 3: The 0% APR Capital Roadmap',
    desc: 'Your blueprint to securing cards with 18 months of no interest.',
    value: 97
  }, {
    icon: '🎁',
    title: 'Bonus 4: Business Credit Blueprint',
    desc: 'Build business credit that DOES NOT report to your personal name.',
    value: 47
  }, {
    icon: '🎁',
    title: 'Bonus 5: Weekly Dispute Tracker',
    desc: 'The tool to organize your legal attack.',
    value: 47
  }];
  return <section className="py-24 px-4 bg-[#0a0a0f] relative" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-[#151520] to-[#0a0a0f] rounded-3xl border-2 border-gold/30 p-8 md:p-12 shadow-2xl shadow-gold/10" data-id="element-122">
          <div className="text-center mb-10" data-id="element-123">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-124">
              Here is what you get today with the <br data-id="element-125" />
              <span className="text-gold" data-id="element-126">"2026 Credit Hacker Bundle"</span>
            </h2>
          </div>

          <div className="space-y-4 mb-12" data-id="element-127">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/10 hover:border-gold/30 transition-colors" data-id="element-128">
                <div className="text-2xl mt-1" data-id="element-129">{item.icon}</div>
                <div className="flex-1" data-id="element-130">
                  <h3 className="text-lg font-bold text-white flex flex-wrap items-center gap-2" data-id="element-131">
                    {item.title}
                    <span className="text-sm font-normal text-gray-500 line-through" data-id="element-132">
                      (${item.value} Value)
                    </span>
                  </h3>
                  <p className="text-gray-400 mt-1" data-id="element-133">{item.desc}</p>
                </div>
                <CheckCircle2 className="w-6 h-6 text-green-500 hidden sm:block mt-2 flex-shrink-0" data-id="element-134" />
              </motion.div>)}
          </div>

          <div className="border-t border-white/10 pt-8 text-center" data-id="element-135">
            <div className="mb-2" data-id="element-136">
              <span className="text-xl text-gray-400" data-id="element-137">TOTAL VALUE: </span>
              <span className="text-2xl text-red-500 line-through font-bold" data-id="element-138">
                $552.00
              </span>
            </div>
            <div className="mb-8 relative inline-block" data-id="element-139">
              <span className="absolute -top-4 -right-8 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full transform rotate-12" data-id="element-140">
                SAVE 91%
              </span>
              <span className="text-2xl text-white" data-id="element-141">PRICE TODAY: </span>
              <span className="text-5xl md:text-6xl text-gold font-bold" data-id="element-142">
                $47.00
              </span>
              <p className="text-gray-400 mt-2" data-id="element-143">(One-time payment)</p>
            </div>

            <CtaSection showTrustBadges={true} data-id="element-144" />
          </div>
        </motion.div>
      </div>
    </section>;
}